import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = "https://xyvhmndlnvlayostclgk.supabase.co"
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inh5dmhtbmRsbnZsYXlvc3RjbGdrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg4NTQzOTMsImV4cCI6MjA4NDQzMDM5M30.BPlYO7zGREqGTvjiCezffEbSwvwTGPxiwTGSDD-krvs"

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
})
